import { ProgressBar } from "react-bootstrap";
import EmptyStateTable from "../../../../components/emptyState/emptyStateTabel";

function Tel1ParticipantTable({ participantData = [] }) {
  const getVariant = (val) => {
    if (val <= 2) return "danger";
    if (val <= 4) return "warning";
    if (val <= 5) return "success";
    if (val <= 6) return "info";
  };
  return (
    <>
      <div className="table-responsive">
        <table className="table table-hover text-nowrap">
          <thead>
            <tr>
              <th className="border-top-0 pt-0 pb-2">No.</th>
              <th className="border-top-0 pt-0 pb-2">Name</th>
              <th className="border-top-0 pt-0 pb-2">Program</th>
              <th className="border-top-0 pt-0 pb-2">Tool</th>
              <th className="border-top-0 pt-0 pb-2">Fasilitator</th>
              <th className="border-top-0 pt-0 pb-2">Overall</th>
            </tr>
          </thead>
          <tbody>
            {participantData.length > 0 ? (
              participantData.map((val, index) => (
                <tr key={index}>
                  <td className="align-middle">{index + 1}</td>
                  <td className="align-middle">{val.name === "-" ? "Participant " + (index + 1) : val.name}</td>
                  <td className="align-middle">
                    <ProgressBar label={val.result.program.toFixed(2)} now={val.result.program} variant={getVariant(val.result.program)} min={0} max={6} />
                  </td>
                  <td className="align-middle">
                    <ProgressBar label={val.result.tool.toFixed(2)} now={val.result.tool} variant={getVariant(val.result.tool)} min={0} max={6} />
                  </td>
                  <td className="align-middle">
                    <ProgressBar label={val.result.fasilitators.toFixed(2)} now={val.result.fasilitators} variant={getVariant(val.result.fasilitators)} min={0} max={6} />
                  </td>
                  <td className="align-middle">
                    <ProgressBar label={val.result.overAll.toFixed(2)} now={val.result.overAll} variant={getVariant(val.result.overAll)} min={0} max={6} />
                  </td>
                </tr>
              ))
            ) : (
              <EmptyStateTable colSpan={6} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default Tel1ParticipantTable;
